import React from 'react';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { SaveAuditLogs } from '../../../../../../data/UserAuditLogs';
import { postAPI_ResendInvite, gAPI_Group_By_Id } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

function ReinviteUserForm({
  id, userName
}) {

  const handleReInvite = data => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    })
      .then(res => {
        const auditData = {
          groupId: getGroupID(),
          itemId: data,
          action: "Resend Invite link by " + userName,
          content: { groupName: res.data.name },
          logType: "UsersRoles",
          createdBy: userName
        };
        SaveAuditLogs(auditData);
        AxiosAPI({
          method: 'put',
          url: `${postAPI_ResendInvite}/${data}/resend-invite`,
          data: {
            groupName: res.data.name
          },
        }).then(resnew => {
          navigator.clipboard.writeText(resnew.data.url);
          NotificationManager.success(
            "",
            "Invitation sent successfully and URL copied to clipboard.",
            3000,
            null,
            null,
            "success"
          );
        }
        );
      })
      .catch(err => console.error(err));
  };

  return (

    <Button
      color="primary"
      size="sm"
      onClick={() => handleReInvite(id)}
      outline
    >
      Resend
    </Button>

  );
}
const mapStateToProps = ({ settings }) => {
  const { userName } = settings;
  return { userName };
};
export default injectIntl(connect(mapStateToProps, {})(ReinviteUserForm));
